import script from "./HelloModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelloModal.vue?vue&type=script&setup=true&lang=ts"

import "./HelloModal.vue?vue&type=style&index=0&id=5fdbf244&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fdbf244"]])

export default __exports__